<template>
  <div class="root ma-2" >
    <div class="column card">
      <div class="row bottom-border">
        <div class="item font-weight-bold">First Name</div>
        <div class="item">{{user.firstName}}</div>
      </div>
      <div class="row bottom-border">
        <div class="item font-weight-bold">Last Name</div>
        <div class="item">{{user.lastName}}</div>
      </div>
      <div class="row bottom-border">
        <div class="item font-weight-bold">Username</div>
        <div class="item">{{user.userName}}</div>
      </div>
      <div class="row bottom-border">
        <div class="item font-weight-bold">Email</div>
        <div class="item">{{user.email}}</div>
      </div>
      <div class="row bottom-border">
        <div class="item font-weight-bold">Password</div>
        <div class="item">
          <v-btn color="error" @click="$router.push('/account/change-password')" small>change password</v-btn>
        </div>
      </div>
      <div class="row bottom-border">
        <div class="item font-weight-bold">Role</div>
        <div class="item">{{user.roleName}}</div>
      </div>
      <div class="row bottom-border">
        <div class="item font-weight-bold">Status</div>
        <div class="item">{{user.active? "Active":"Inactive"}}</div>
      </div>
      <div class="row">
        <div class="item font-weight-bold">Notes</div>
        <div class="item">{{user.notes}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import snackbar from "../../mixins/snackbar";
import authApi from "../../api/auth";
import axios from "../../api/axios";

export default {
  data() {
    return {
      user: {}
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      axios.get("/account/details").then(r => {
        if (r.data.ok) {
          this.user = r.data.d;
        }
      });
    }
  }
};
</script>

<style scoped>
.root {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.card {
  padding: 10px;
  width: 500px;
  background-color: white;
  color: #555555;
}
.column {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
}
.bottom-border {
  border-bottom: 1px solid #eeeeee;
}
.item {
  width: 200px;
  text-align: left;
  padding: 15px 0px;
}
</style>
